module.exports = __webpack_public_path__ + "static/media/li.f37f498e.svg";